import React, { useEffect, useState } from "react";
import ArrivalsCard from "./ArrivalsCard";
import { Typography, Grid, Button } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import Firestore from "../firebase/FireStore";

function Arrivals() {
  const [products, setProducts] = useState(null);
  useEffect(() => {
    async function fetchData() {
      let new_products = await Firestore.getAllItems();
      setProducts([...new_products.val]);
    }
    fetchData();
  }, [products]);

  return (
    <div>
      <Typography
        variant="h2"
        sx={{
          marginLeft: { md: "50px" },
          textAlign: { md: "left", xs: "center" },
        }}
      >
        New Arrivals
      </Typography>
      <Grid container gap={0} className="mt-1 flex items-center justify-center">
        {products != null && products.length >= 4 ? (
          <>
            {" "}
            <ArrivalsCard
              itemId={products.sort((a, b) => a.timestamp < b.timestamp)[0].itemId}
              backgroundImage={
                products.sort((a, b) => a.timestamp < b.timestamp)[0].image
              }
              name={products.sort((a, b) => a.timestamp < b.timestamp)[0].name}
              price={
                products.sort((a, b) => a.timestamp < b.timestamp)[0].price
              }
              sx={{
                borderRight: { md: 3 },
                borderTop: { md: 3 },
                borderBottom: { md: 3 },
                borderLeft: { md: 3 },
              }}
            />
            <ArrivalsCard
              itemId={products.sort((a, b) => a.timestamp < b.timestamp)[1].itemId}
              backgroundImage={
                products.sort((a, b) => a.timestamp < b.timestamp)[1].image
              }
              name={products.sort((a, b) => a.timestamp < b.timestamp)[1].name}
              price={
                products.sort((a, b) => a.timestamp < b.timestamp)[1].price
              }
              sx={{
                borderTop: { md: 3 },
                borderBottom: { md: 3 },
                borderRight: { md: 3 },
              }}
            />
            <ArrivalsCard
              itemId={products.sort((a, b) => a.timestamp < b.timestamp)[2].itemId}
              backgroundImage={
                products.sort((a, b) => a.timestamp < b.timestamp)[2].image
              }
              name={products.sort((a, b) => a.timestamp < b.timestamp)[2].name}
              price={
                products.sort((a, b) => a.timestamp < b.timestamp)[2].price
              }
              sx={{
                borderTop: { md: 3 },
                borderBottom: { md: 3 },
                borderRight: { md: 3 },
              }}
            />
            <ArrivalsCard
              itemId={products.sort((a, b) => a.timestamp < b.timestamp)[3].itemId}
              backgroundImage={
                products.sort((a, b) => a.timestamp < b.timestamp)[3].image
              }
              name={products.sort((a, b) => a.timestamp < b.timestamp)[3].name}
              price={
                products.sort((a, b) => a.timestamp < b.timestamp)[3].price
              }
              sx={{
                borderTop: { md: 3 },
                borderBottom: { md: 3 },
                borderRight: { md: 3 },
              }}
            />
          </>
        ) : null}
      </Grid>
      <div className="mt-5 flex items-center justify-center">
        <Button
          size="large"
          variant="outlined"
          sx={{
            borderColor: "green",
            color: "green",
            ":hover": { borderColor: "darkgreen", color: "darkgreen" },
          }}
        >
          View All &nbsp; <ArrowOutwardIcon />
        </Button>
      </div>
    </div>
  );
}

export default Arrivals;
